const STORAGE_KEY = 'contsuite_referral_code';

export function normalizeReferralCode(code) {
  if (!code) return '';
  return String(code).trim().toUpperCase().replace(/[^A-Z0-9]/g, '');
}

export function captureReferralFromSearch(search = '') {
  const params = new URLSearchParams(search);
  const raw = params.get('ref') || params.get('referral');
  const code = normalizeReferralCode(raw);
  if (!code) return '';
  try {
    localStorage.setItem(STORAGE_KEY, code);
  } catch {
    // Sin almacenamiento local
  }
  return code;
}

export function getStoredReferralCode() {
  try {
    return normalizeReferralCode(localStorage.getItem(STORAGE_KEY) || '');
  } catch {
    return '';
  }
}

export function clearStoredReferralCode() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
